import { icons } from 'utils/constants';
import { generatePreSignedUrl, handleViewPreview } from 'utils/helpers';

const DetailItem = ({
  label,
  value,
  type,
  fileName,
  handleFileDownload,
  labelClassName,
  filePath,
  isView,
}) => {
  const isValidFile = fileName && fileName !== '-';

  const renderUrlContent = () => {
    if (!isValidFile) {
      return <div className="text-14-300-18 color-black-olive cmb-8">-</div>;
    }

    if (isView) {
      return (
        <div className="d-flex align-items-center gap-2">
          <span
            className="text-14-300-18 color-new-car cmb-8"
            style={{
              wordBreak: 'break-word',
              maxWidth: '100%',
              display: 'inline-block',
            }}
          >
            {value}
          </span>

          {/* Download Button */}
          <button
            type="button"
            onClick={(e) => handleFileDownload?.(e, fileName, filePath)}
            className="p-0 border-0 bg-transparent d-flex align-items-center"
          >
            <img
              src={icons.ArrowDownward}
              alt="Download"
              width="18"
              height="18"
            />
          </button>

          {/* View Button opens modal */}
          <button
            type="button"
            className="p-0 border-0 bg-transparent d-flex align-items-center"
            onClick={(e) => handleViewPreview(fileName, filePath)}
          >
            <img src={icons.blueEyeIcon} alt="View" width="18" height="18" />
          </button>
        </div>
      );
    }

    return (
      <div className="d-flex align-items-center gap-2">
        <button
          type="button"
          onClick={(e) => handleFileDownload?.(e, fileName, filePath)}
          className="p-0 border-0 bg-transparent d-flex align-items-center"
        >
          <img
            src={icons.ArrowDownward}
            alt="Download"
            width="18"
            height="18"
          />
        </button>

        <span
          className="text-14-300-18 color-new-car cmb-8"
          style={{
            wordBreak: 'break-word',
            maxWidth: '100%',
            display: 'inline-block',
          }}
        >
          {value}
        </span>
      </div>
    );
  };

  return (
    <>
      <div className="text-14-400-18 color-1717 cmb-8 cmt-8">{label}</div>

      {type === 'url' ? (
        renderUrlContent()
      ) : (
        <div
          className={`text-14-300-18 text-wrap cmb-8 ${
            labelClassName || 'color-black-olive'
          }`}
        >
          {value || '-'}
        </div>
      )}
    </>
  );
};

export default DetailItem;
